import { AloftPrice, AloftPriceJSON, orUndefined } from '@aloft/toolkit-shared';
import { Flex, Typography } from '@aloft/toolkit-sui';

import { FieldPath, useWatch } from 'react-hook-form';

import { PropertyGridForm } from '../types.ts';
import { readOnlyFieldProps, readOnlyFieldTypographyProps } from './styles.ts';
import { PropertyGridFieldProps } from './types.ts';

export const ReadOnlyUnitRateField = ({
  columnIndex,
  field,
  colSpan = 1,
  control,
}: PropertyGridFieldProps) => {
  const { manualAdjustmentKey, unit, unitRateKey } = field;

  const unitRateFieldName =
    `columns.${columnIndex}.propertyData.editableData.salesComparison.unitRates.${unitRateKey}` as FieldPath<PropertyGridForm>;

  const storedUnitRate = useWatch({ control, name: unitRateFieldName }) as
    | AloftPriceJSON
    | undefined;

  if (!unitRateKey) return <Typography {...readOnlyFieldProps(colSpan)}>-</Typography>;

  const displayRate = orUndefined((value: AloftPriceJSON) => AloftPrice.schema.parse(value))(
    storedUnitRate,
  );
  const forceNegative = manualAdjustmentKey === 'actualAge' && unitRateKey === 'actualAge';
  const normalizedRate =
    forceNegative && displayRate
      ? AloftPrice.fromUnitAmount(-Math.abs(displayRate.unitAmount), displayRate.currency)
      : displayRate;
  const rateText = normalizedRate?.toString(true);

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      __dangerDoNotUseSx={{
        ...readOnlyFieldProps(colSpan).__dangerDoNotUseSx,
        paddingRight: '6px',
      }}
    >
      <Typography {...readOnlyFieldTypographyProps} __dangerDoNotUseSx={undefined}>
        {rateText ?? '-'}
      </Typography>
      {unit && displayRate && (
        <Typography
          variant="body2"
          inline
          color="textSecondary"
          __dangerDoNotUseSx={{
            flexShrink: 0,
            lineHeight: 1,
          }}
        >
          /{unit}
        </Typography>
      )}
    </Flex>
  );
};
